import React from 'react';

import { Space, theme,Typography } from 'antd';

import { TeamOutlined } from '@ant-design/icons';

type Props = {
    icon: typeof TeamOutlined,
    title: string,
}

export function SectionTitle({ icon: Icon, title }: Props ) {
    const { token } = theme.useToken();

    return (
        <Space align="baseline">
            <Icon style={{ fontSize: 20, color: token.colorInfo }} />

            <Typography.Title level={5} style={{ marginTop: 8, marginBottom: 0 }}>
                {title}
            </Typography.Title>
        </Space>
    );
}
